import React, { useState, useEffect, useCallback, use, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './DevisList.css';
//import InvoiceForm from '../InvoiceFormx';
import { Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Pagination, PaginationItem, PaginationLink, Popover, PopoverBody, Row, Spinner } from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaCashRegister, FaCheckCircle, FaEdit, FaEllipsisH, FaFilePdf, FaFilter, FaInfo, FaPlus, FaSearch, FaTrash } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import DevisForm from './DevisForm';
import { devisActions } from '../../sagas/devisSlice';
import { useNavigate } from 'react-router-dom';
import { formatPrice, convertNumberToWords } from '../../helpers/utility';

import jsPDF from 'jspdf';
import "jspdf-autotable";
import autoTable from 'jspdf-autotable';
import { commandeActions } from '../../sagas/commandeSlice';
import BCForm from './BCForm';
import { productActions } from '../../sagas/productSlice';
import { debounce } from 'lodash';
import { clientActions } from '../../sagas/clientSlice';
import Select from "react-select";
import { generateDoc } from '../../helpers/generateDoc';

const BonCommandeList = () => {
    const dispatch = useDispatch();
    const list = useSelector((state) => state.commande.list);
    const loading = useSelector((state) => state.commande.loading);
    const [filter, setFilter] = useState('');
    const { company } = useSelector(state => state.auth);
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();
    const [selectedCommande, setSelectedCommande] = useState(null);
    const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unites
    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const searchInputRef = useRef(null);
    const clients = useSelector(state => state.clients.clients);
    const [selectedClient, setSelectedClient] = useState(null);

    const [filters, setFilters] = useState({
        clientId: null,
        chantierId: null,
        dateFrom: formatDate(todayDate),
        dateTo: formatDate(tomorrowDate),
        query: ''
    });

    useEffect(() => {
        dispatch(clientActions.search({ query: "" }));
    }, []);

    useEffect(() => {
        let payload = {
            ...filters,
        };
        dispatch(commandeActions.list(payload));
        dispatch(productActions.findAllUnites());

    }, []);

    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [list]);


    useEffect(() => {
        dispatch(commandeActions.list({
            ...filters,
        }));
    }, [filters.clientId, filters.chantierId, filters.dateFrom, filters.dateTo, filters.commercialId]);


    const handleGeneratePdf = (bonCommande) => {
        // First, ask the user whether they want to generate the PDF with TTC or HT prices
        Swal.fire({
            title: t('commande.pdfPriceOption', 'Prix à afficher'),
            text: t('commande.pdfPriceOptionText', 'Choisissez le type de prix à afficher dans le PDF'),
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t('commande.prixTTC', 'Prix TTC'),
            cancelButtonText: t('commande.prixHT', 'Prix HT'),
            showCloseButton: true,
            closeButtonHtml: '&times;',
        }).then((result) => {
            // If user closes the dialog without choosing, don't generate PDF
            if (result.dismiss === Swal.DismissReason.close) {
                return;
            }

            // Determine if we should show TTC prices (confirmed) or HT prices (canceled)
            const showTTCPrices = result.isConfirmed;

            generateDoc("bon_commande", {
                matjarDoc: bonCommande,
                sellerModel: company,
                priceMode: showTTCPrices ? "TTC" : "HT",    // or "TTC"
                open: true,
            });
        });
    };

    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        if (selectedCommande) {
            setSelectedCommande(null);
        }
        let payload = {
            ...filters,
        };
        dispatch(commandeActions.list(payload));
    };

    const clientOptions = clients?.map(client => ({
        value: client.id,
        label: client.typeClient === 'PARTICULIER'
            ? `${client.nom} ${client.prenom || ''} `
            : client.entreprise,
        chantiers: client.chantiers || []
    })) ?? [];

    const clientOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...clientOptions
    ];

    const chantierOptions = selectedClient?.chantiers?.map(chantier => ({
        value: chantier.id,
        label: `${chantier.code} - ${chantier.nom}`,
        ...chantier
    })) || [];
    const chantierOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...chantierOptions
    ];

    const clearFilters = () => {
        setFilters({
            query: '',
            clientId: null,
            chantierId: null,
            dateFrom: formatDate(todayDate),
            dateTo: formatDate(tomorrowDate)
        });
        debouncedSearch()
    };

    const handleBonLivraison = (commande) => {
        if (!commande.entrepotId) {
            Swal.fire({
                icon: 'warning',
                title: t('commande.noEntrepot', 'Entrepôt non défini'),
                text: t('commande.noEntrepotMessage', 'Veuillez définir un entrepôt pour cette commande avant de la convertir en bon de livraison.'),
                confirmButtonColor: '#3085d6',
            });
            return;
        }

        Swal.fire({
            title: 'Confirmation',
            text: "Cette commande sera convertie en bon de livraison. Voulez-vous confirmer?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(commandeActions.validerCommande({
                    id: commande.id,
                    onSuccess: () => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Validée!',
                            text: 'La commande a été convertie en bon de livraison avec succès.',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        // Refresh the list
                        let payload = {
                            ...filters,
                        };
                        dispatch(commandeActions.list(payload));
                    },
                    onError: (error) => {
                        // Add error handling
                        Swal.fire({
                            icon: 'error',
                            title: 'Erreur!',
                            text: `Une erreur est survenue: ${error?.message || 'Veuillez réessayer plus tard.'}`,
                            confirmButtonColor: '#3085d6',
                        });
                    }
                }));
            }
        });
    };

    const handleUpdateCommande = (commande) => {
        setSelectedCommande(commande);
        setShowModal(true);
    }

    const debouncedSearch = () => {
        dispatch(commandeActions.list({
            ...filters,
        }));
    }

    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaCashRegister className="text-primary me-2" />
                                {t('commande.list')}
                            </h4>
                            <div className="d-flex align-items-center">
                                <Button color="primary" onClick={handleShowModal}
                                >
                                    <FaPlus className="mr-2" /> {t('commande.newCommande')}
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>
                    {loading ? ( // Show spinner when loading
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <div className="mt-2 text-muted">{t('common.loading')}</div>
                        </div>
                    ) : (
                        <>
                            <div className="filter-container mb-4">
                                <Row className="mb-3 g-2 align-items-end">
                                    <Col lg={3} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('reglement.search')}</Label>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light">
                                                    <FaSearch />
                                                </span>
                                                <Input
                                                    type="text"
                                                    innerRef={searchInputRef}
                                                    placeholder={t('commande.searchPlaceholder')}
                                                    value={filters.query}
                                                    onChange={e => {
                                                        const value = e.target.value.toUpperCase();
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            query: value
                                                        }));
                                                    }}
                                                    className="text-uppercase"
                                                    style={{ textTransform: 'uppercase' }}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter') {
                                                            debouncedSearch(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup className="mb-0">
                                            <Label htmlFor="clientId">{t('bonLivraison.client')}:</Label>
                                            <Select
                                                id="clientId"
                                                options={clientOptionsWithAll}
                                                value={clientOptionsWithAll.find(option => option.value === filters.clientId)}
                                                onChange={(selectedOption) => {
                                                    setFilters(f => ({ ...f, clientId: selectedOption ? selectedOption.value : null }));
                                                    setSelectedClient(selectedOption);
                                                }}
                                                placeholder={t('bonLivraison.selectClient')}
                                                isSearchable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup className="mb-0">
                                            <Label htmlFor="chantierId">
                                                {t('chantier.title', 'Chantier')}:
                                            </Label>
                                            <Select
                                                id="chantierId"
                                                options={chantierOptionsWithAll}
                                                value={chantierOptionsWithAll.find(option => option.value === filters?.chantierId) || null}
                                                onChange={(selectedOption) => setFilters(f => ({ ...f, chantierId: selectedOption ? selectedOption.value : null }))}
                                                placeholder={t('chantier.select', 'Sélectionner...')}
                                                isSearchable
                                                isClearable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateFrom" className="mb-1">Date début</Label>
                                            <Input
                                                type="date"
                                                id="dateFrom"
                                                value={filters.dateFrom}
                                                onChange={e => setFilters(f => ({ ...f, dateFrom: e.target.value }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateTo" className="mb-1">Date fin</Label>
                                            <Input
                                                type="date"
                                                id="dateTo"
                                                value={filters.dateTo}
                                                onChange={e => setFilters(f => ({ ...f, dateTo: e.target.value }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={1} md={1} sm={6} xs={12} className="d-flex align-items-end">
                                        <Button
                                            color="secondary"
                                            onClick={clearFilters}
                                            title={t('common.clearFilters')}
                                            className="mb-3"
                                            style={{ minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <FaFilter />
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                            <table className="table table-hover table-striped table-bordered" style={{ fontSize: '0.8rem' }}>
                                <thead className="thead-light">
                                    <tr>
                                        <th className="align-middle text-center">{t('commande.numero')}</th>
                                        <th className="align-middle text-center">{t('commande.client')}</th>
                                        <th className="align-middle text-center">{t('devis.chantier')}</th>
                                        <th className="align-middle text-center">{t('commande.devis')}</th>
                                        <th className="align-middle text-center">{t('common.user')}</th>
                                        <th className="align-middle text-center">{t('commande.dateCreation')}</th>
                                        <th className="align-middle text-center">{t('commande.dateModification')}</th>
                                        <th className="align-middle text-center">{t('commande.dateOperation')}</th>
                                        <th className="align-middle text-center">{t('devis.montantTTC')}</th>
                                        <th className="align-middle text-center">{t('devis.montantHT')}</th>
                                        <th className="align-middle text-center">{t('devis.montantTVA')}</th>
                                        <th className="align-middle text-center">{t('commande.status')}</th>
                                        <th className="align-middle text-center">{t('common.actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list.map((commande) => (
                                        <tr key={commande.id}>
                                            <td className="align-middle text-center">{commande.numero}</td>
                                            <td className="align-middle text-center">
                                                {commande.clientNom}
                                            </td>
                                            <td className="align-middle text-center">
                                                {commande.chantierNom || 'N/A'}
                                            </td>
                                            <td className="align-middle text-center">
                                                {commande.devisNumero || 'N/A'}
                                            </td>
                                            <td className="align-middle text-center">{commande.createdBy || '-'}</td>
                                            <td className="align-middle text-center">{commande.dateCreation}</td>
                                            <td className="align-middle text-center">{commande.updatedAt || 'N/A'}</td>
                                            <td className="align-middle text-center">{commande.dateOperation || 'N/A'}</td>
                                            <td className="align-middle text-center">{formatPrice(commande.montantTotalTTC, false)}</td>
                                            <td className="align-middle text-center">{formatPrice(commande.montantTotalHT, false)}</td>
                                            <td className="align-middle text-center">{formatPrice(commande.montantTotalTaxe, false)}</td>
                                            <td className="align-middle text-center">
                                                {commande.status === 'EN_ATTENTE' && (
                                                    <span className="badge bg-secondary">{t('commande.statusDraft')}</span>
                                                )}
                                                {commande.status === 'VALIDE' && (
                                                    <span className="badge bg-success">{t('commande.statusValidated')}</span>
                                                )}
                                                {commande.status === 'LIVRE' && (
                                                    <span className="badge bg-primary">{t('commande.statusDelivered')}</span>
                                                )}
                                                {commande.status === 'ANNULE' && (
                                                    <span className="badge bg-danger">{t('commande.statusCancelled')}</span>
                                                )}
                                            </td>
                                            <td className="align-middle text-center">
                                                <div className="btn-group">
                                                    <Button
                                                        color="secondary"
                                                        title={t('commande.downloadPdf')}
                                                        onClick={() => handleGeneratePdf(commande)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaFilePdf />
                                                    </Button>

                                                    {(commande.status === 'EN_ATTENTE' || commande.status === 'VALIDE') && <Button
                                                        color="success"
                                                        title={t('commande.bonLivraison')}
                                                        onClick={() => handleBonLivraison(commande)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaCheckCircle />
                                                    </Button>}

                                                    <Button
                                                        color="warning"
                                                        title={t('commande.edit')}
                                                        onClick={() => handleUpdateCommande(commande)}
                                                        size="sm"
                                                        className='me-1'
                                                    >
                                                        <FaEdit />
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {list.length === 0 && (
                                        <tr>
                                            <td colSpan="13" className="text-center py-4">
                                                <div className="text-muted">{t('commande.noCommande')}</div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr className="bg-light fw-bold">
                                        <td colSpan="8" className="text-end">{t('common.totals')}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantTotalTTC || 0), 0), false)}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantTotalHT || 0), 0), false)}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantTotalTaxe || 0), 0), false)}</td>
                                        <td colSpan="2"></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </>)}
                </CardBody>
            </Card>
            <Modal isOpen={showModal} toggle={handleCloseModal} size="xl"
                className="modal-fullscreen-lg-down"
                style={{ maxWidth: '95%', width: '95%', margin: '10px auto' }}
            >
                <ModalHeader toggle={handleCloseModal}>{selectedCommande ? `Commande N°: ${selectedCommande.numero}` : t('commande.newCommande')}</ModalHeader>
                <ModalBody>
                    <BCForm preloadedCompany={company} commande={selectedCommande} onClose={handleCloseModal} />
                </ModalBody>
            </Modal>
        </Container>
    );
};

export default BonCommandeList;